import { Container } from '@symbiotic/green-state';

import { state } from './state';
import { PortalApp } from '../portal-react-app/PortalApp';
import { RegistrationResolver, PluginRegistration } from './RegistrationResolver';
import { PluginValidator } from './PluginValidator';
import { PluginLoader } from './PluginLoader';
import { getContainer } from './ioc';

const getCurrentScript = () => {
  // Plugins are required to register synchronously (documented in the README).
  // So long as this is the case document.currentScript will do what we want here,
  // but we fall back to the last script to avoid the possibility of returning null.
  // (For IE11 we rely on current-script-polyfill.)
  return document.currentScript || document.scripts[document.scripts.length - 1];
};

export const bootstrap = async (overrideContainer?: Container) => {

  const container = overrideContainer || await getContainer();
  const pluginLoader: PluginLoader = container.get(PluginLoader);

  (window as any).__registerAsurePortalPlugin = async (registration: PluginRegistration) => {
      try {
      // keep this at the start of this function, as some browsers may lose track of
      // the current script after an async callback (i.e. an await statement below)
      const currentScript = getCurrentScript();

      // wait to get resolver until we need it, so PortalFramework has been registered with the container.
      const resolver: RegistrationResolver = container.get(RegistrationResolver);
      const plugin = await resolver.resolve(registration);

      const validator: PluginValidator = container.get(PluginValidator);
      const { name, dashboardWidgets, pages } = validator.validate(plugin);

      if (pluginLoader.timedOut) {
        throw new Error(`Plugin "${name}" loaded after timeout expired.`);
      }


      // get sort key assigned when plugin script was injected
      const pluginKey = currentScript.id || 'plugin-999';

      Array.prototype.push.apply(state.dashboardWidgets, dashboardWidgets.map((widget, i) => {
        // combine plugin key with widget index to create widget sort key
        // e.g. 'plugin-002-widget-003' for second plugin's third widget
        const sortKey = `${pluginKey}-widget-${String(i + 1).padStart(3, '0')}`;
        return { ...widget, sortKey };
      }));

      Array.prototype.push.apply(state.pages, pages);

    } catch (e) {
      console.error(`Plugin failed to register: ${e.message}`);
    }
  };

  container.get(PortalApp).start(pluginLoader.loadPlugins);
};



// WEBPACK FOOTER //
// ./src/framework/bootstrap.ts